import type { DepositLookupResponse } from '@massilia/queries'

import { useState } from 'react'

import { DepositBookingInfo } from './deposit-booking-info'
import { DepositLookupForm } from './deposit-lookup-form'

interface BookingState {
  booking: DepositLookupResponse
  credentials: { dossierNumber: string; email: string; lastName: string }
}

interface DepositPaymentPageProps {
  initialValues?: {
    dossierNumber?: string
    email?: string
    lastName?: string
  }
}

export function DepositPaymentPage({ initialValues }: DepositPaymentPageProps) {
  const [bookingState, setBookingState] = useState<BookingState | null>(null)

  if (bookingState) {
    return (
      <DepositBookingInfo
        booking={bookingState.booking}
        credentials={bookingState.credentials}
        onBack={() => setBookingState(null)}
      />
    )
  }

  return (
    <DepositLookupForm
      initialValues={initialValues}
      onBookingFound={(booking, credentials) => setBookingState({ booking, credentials })}
    />
  )
}
